<template>
  <span>
    <Dialog header="Copiar Nota Fiscal" :visible.sync="showCopiarNota" :modal="true" :style="{ width: '50vw' }"
      :closable="false">
      <div class="container-fluid">
        <div id="topo" class="row">
          <div class="col-md-12 mb-2">
            <Message severity="warn" v-if="isEmissaoTesteValidacao">Informe o número de uma nota real, para realizar a
              cópia para o ambiente de testes!</Message>
            <label v-if="this.idCliente === '38f4b9f6-5cbe-4adf-bc09-b62f041b9d33'" for="tipoTomador">Listagem de Notas
              Fiscais: *</label>
            <label v-else for="tipoTomador">Número da Nota Fiscal: *</label>
            <span class="p-fluid" style="width: 100%;">
              <AutoComplete v-if="this.idCliente === '38f4b9f6-5cbe-4adf-bc09-b62f041b9d33'" id="notaFiscal"
                v-model="selectedNotaFiscal" :dropdown="true" :suggestions="filteredNotas"
                @complete="searchNotaFiscal($event)" field="numero" placeholder="Selecionar Nota Fiscal"
                style="width: 100%;">
                <template #item="slotProps">
                  <div class="p-fluid" style="max-width: 50vw; z-index: 999 !important;">
                    {{ slotProps.item.detailCopiarNota }}
                  </div>
                </template>
              </AutoComplete>
              <InputText v-else v-model="numeroNota" type="number" />
            </span>
          </div>
        </div>
      </div>

      <hr />

      <div class="container-fluid">
        <div class="row d-flex align-items-end">
          <div>
            <Button @click="copiarNotaFiscal()" href="#topo" type="button" label="Copiar"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" />
          </div>

          <div>
            <Button @click="showCopiarNota = false" type="button" label="Cancelar"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>
  </span>
</template>

<script>
import LoginService from "@/services/acesso/login.service";
import NotaFiscalService from "@/services/nfse/notafiscal.service";
import NotaFiscal from "@/models/nfse/NotaFiscal";
import NotaFiscalNacionalService from "@/services/nfse/notafiscalnacional.service";

export default {
  name: "CopiarNotaFiscal",

  data() {
    return {
      currentUser: null,
      notaFiscal: new NotaFiscal(),
      showCopiarNota: false,
      selectedNotaFiscal: null,
      filteredNotas: null,
      dpsId: null,
      numeroNota: null,
      idCliente: null,
      dataAtual: null,
      anoAtual: null,
      isEmissaoTesteValidacao: false
    };
  },

  created() {
    this.currentUser = LoginService.currentUserValue;
    this.copiarNotaFiscalCallback = (dados) => {
      this.numeroNota = dados.numero;
      this.dpsId = dados.dpsId;
      this.isEmissaoTesteValidacao = dados.isEmissaoTesteValidacao;
      if (this.dpsId != null && this.dpsId != undefined) {
        this.copiarNotaFiscalExecucao(this.dpsId);
      } else {
        this.exibirDialogCopiarNota();
      }
    };
    this.$root.$on("notaFiscal:copiar", this.copiarNotaFiscalCallback);
    this.idCliente = this.currentUser.usuario.idCliente;
    this.dataAtual = new Date();
    this.anoAtual = this.dataAtual.getFullYear();
  },

  destroyed() {
    if (this.copiarNotaFiscalCallback) {
      this.$root.$off("notaFiscal:copiar", this.copiarNotaFiscalCallback);
    }
  },

  methods: {
    exibirDialogCopiarNota() {
      if (this.$parent.notaFiscal) {
        this.numeroNota = this.$parent.notaFiscal.numero;
      }

      this.showCopiarNota = true;
    },

    copiarNotaFiscal() {
      this.copiarNotaFiscalExecucao(null);
    },
    copiarNotaFiscalExecucao(dpsId) {
      if (dpsId != null && dpsId != undefined) {
        this.$parent.processando(true);
        if (this.$parent.carregandoDps !== undefined) {
          this.$parent.carregandoDps = true;
        }
        NotaFiscalNacionalService.obterNotaByDps(this.dpsId)
          .then(data => {
            const nota = data.data;
            return this.carregarDadosNota(nota, dpsId);
          })
          .then(() => {
            this.showCopiarNota = false;
            this.$parent.processando(false);
            if (this.$parent.carregandoDps !== undefined) {
              this.$parent.carregandoDps = false;
            }
          })
          .catch(error => {
            console.error(error);
            this.$parent.processando(false);
            if (this.$parent.carregandoDps !== undefined) {
              this.$parent.carregandoDps = false;
            }
          });
      } else {
        if (this.idCliente === "38f4b9f6-5cbe-4adf-bc09-b62f041b9d33") {
          this.numeroNota = this.selectedNotaFiscal.numero;
        }
        if (this.numeroNota) {
          this.$parent.processando(true);

          NotaFiscalService.findByNumeroCopiarNota(this.numeroNota)
            .then(data => {
              const nota = data.data;
              return this.carregarDadosNota(nota, null);
            })
            .then(() => {
              this.showCopiarNota = false;
              this.$parent.processando(false);
            })
            .catch(error => {
              console.error(error);
              this.$parent.processando(false);
            });
        } else {
          this.$root.$emit(
            "alert:warn",
            "O número da Nota Fiscal deve ser informado!"
          );
        }
      }
    },
    carregarDadosNota(nota, dpsId) {
      if (nota) {
        this.$parent.novaNotaFiscal();

        if (nota.tomadorDados) {
          if (nota.tomadorDados.tipo != "N") {
            this.$parent.selectedPessoa = nota.tomadorDados;

            if (nota.intermediarioDados && this.currentUser.configuracao.idBolIntermediario && this.currentUser.configuracao.idBolIntermediario == "S") {
              this.$parent.selectedTipoIntermediario = this.$parent.tiposIntermediario.filter(
                tipo => tipo.key == "S"
              )[0];
              this.$parent.selectedPessoaIntermediario = nota.intermediarioDados;
            } else {
              this.$parent.selectedTipoIntermediario = this.$parent.tiposIntermediario.filter(
                tipo => tipo.key == "N"
              )[0];
            }
          } else {
            this.$parent.selectedTipoTomador = this.$parent.tiposTomador.filter(
              tipo => tipo.key == nota.tomadorDados.tipo
            )[0];
          }
        }
        if(dpsId != null){
          this.$parent.selectedDpsId = dpsId;
          this.$parent.obterDadosDps(this.idCliente, dpsId);
        }
        
        this.$parent.selectedAtividade = null;
        if (nota.contribuinteAtividade && nota.contribuinteAtividade.id) {
          this.$parent.selectedAtividade = nota.contribuinteAtividade;
        }
        this.$parent.selectedServico = nota.contribuinteServico;

        this.$parent.selectedLocalPrestacao = this.$parent.locaisPrestacao.filter(
          local => local.key == (nota.localPrestacao != null ? nota.localPrestacao : 'M')
        )[0];
        this.$parent.selectedTipoRecolhimento = this.$parent.tiposRecolhimento.filter(
          local => local.key == (nota.tipoRecolhimento != null ? nota.tipoRecolhimento : 'N')
        )[0];
        if (nota.tipoContribuicaoSocial && nota.tipoContribuicaoSocial != null && nota.tipoContribuicaoSocial != undefined) {
          this.$parent.selectedTipoContrSociais = this.$parent.tiposContrSociais.filter(
            local => local.key == nota.tipoContribuicaoSocial
          )[0];
        } else {
          this.$parent.selectedTipoContrSociais = this.$parent.tiposContrSociais[0];  
        }

        this.$parent.notaFiscal.valorServico = nota.valorServico;
        this.$parent.notaFiscal.aliquota = nota.valorAliquota;
        this.$parent.notaFiscal.valorDesconto = nota.valorDesconto;
        this.$parent.notaFiscal.valorDescontoIncond =
          nota.valorDescontoIncond;
        this.$parent.notaFiscal.valorDescontoCond =
          nota.valorDescontoCond;
        this.$parent.notaFiscal.valorDescontosDiversos =
          nota.valorDescontosDiversos != null ? nota.valorDescontosDiversos : 0;          
        this.$parent.notaFiscal.discriminacaoServico =
          nota.discriminacaoServico;
        this.$parent.notaFiscal.observacao =
          nota.observacao;
        this.$parent.notaFiscal.valorInss = nota.valorInss;
        this.$parent.notaFiscal.valorIr = nota.valorIr;
        this.$parent.notaFiscal.valorCsll = nota.valorCsll;
        this.$parent.notaFiscal.valorPis = nota.valorPis;
        this.$parent.notaFiscal.valorCofins = nota.valorCofins;
        this.$parent.notaFiscal.outrasRetencoes = nota.outrasRetencoes != null ? nota.outrasRetencoes : 0;
        this.$parent.notaFiscal.valorContribuicaoSocial = nota.valorContribuicaoSocial;

        this.$parent.notaFiscal.valorIrrf = nota.valorIrrf;
        this.$parent.notaFiscal.valorSest = nota.valorSest;
        this.$parent.notaFiscal.valorSenat = nota.valorSenat;
        this.$parent.notaFiscal.numeroArt = nota.numeroArt;
        this.$parent.notaFiscal.numeroCei = nota.numeroCei;

        if (nota.obra && nota.obra.id) {
          this.$parent.selectedObra = nota.obra;
        }
        if (nota.servicoNacional && nota.servicoNacional.id) {
          this.$parent.selectedServicoNacional = nota.servicoNacional;
        }
        if (nota.servicoNbs && nota.servicoNbs.id) {
          this.$parent.selectedNbs = nota.servicoNbs;
        }
        if (nota.servicoIndop && nota.servicoIndop.id) {
          this.$parent.selectedIndop = nota.servicoIndop;
        }
        if (nota.servicoClassTrib && nota.servicoClassTrib.id) {
          this.$parent.selectedClasstrib = nota.servicoClassTrib;
        }


        //carrega o munic de origem e de prestacao
        const promises = [];
        const promiseLocalidade = this.$parent.searchLocalidadeCopiaNota(this.currentUser.configuracao.idCepLocalidadeCliente, nota.idMunicPrestacao);
        if (promiseLocalidade) {
          promises.push(promiseLocalidade);
        }

        if(dpsId == null){
          this.$root.$emit(
            "alert:info:fixed",
            "Os dados da Nota Fiscal informada foram carregados!"
          );
        }else{
          const promiseTela = this.$parent.atualizarDadosTela();
          if (promiseTela && typeof promiseTela.then === 'function') {
            //seta novamente a aliquota pois o metodo acima joga a aliquota padrão do serviço
            this.$parent.notaFiscal.aliquota = nota.valorAliquota;
            console.log(this.$parent.notaFiscal.aliquota);
            promises.push(promiseTela);
            
          }
          
        }

        if (nota.tomadorRemovido == "S") {
          this.$root.$emit(
            "alert:warn:fixed",
            "Os dados do Tomador não foram carregados, pois ele foi removido anteriormente!"
          );
        } else {
          const promisePessoa = this.$parent.atualizarDadosPessoaSelecionada(true);
          if (promisePessoa) {
            promises.push(promisePessoa);
          }
        }

        return Promise.all(promises);
      } else {
        this.$root.$emit(
          "alert:warn",
          "Não foi possível carregar os dados da Nota Fiscal informada!"
        );
        return Promise.resolve();
      }
      
    },
    searchNotaFiscal(event) {
      this.$parent.processando(true);
      setTimeout(async () => {
        this.filteredNotas =
          await NotaFiscalService.findNotasCopiar(
            event.query,
            this.anoAtual
          )
        this.$parent.processando(false);
      }, 250);
    },
  },

  computed: {
    loading() {
      return this.$parent.loading;
    }
  }
};
</script>

<style></style>
